<template>
    <div>
         <section class="hero" id="hero">


        <div class="hero-container">


            <div class="text-hero-container">

                <div class=" text-one">

                    <p>
                        Amahoro, welcome
                    </p>
                    <p>
                        to my portfolio I am
                    </p>
                </div>
                <div class="text-two">
                    <h1 class="title-top">
                        NIYERA
                    </h1>
                    <div class="midle">
                        <div class="midle-container-hero">
                            <div class="middle-star">
    
                                <div class="line line-left">
            
                                </div>
                                <div class="footer-start">
                                    <img src="@/assets/icons8-identité-médicale-50.png" alt="icon">
                                   
                                </div>
                                <div class="line line-right">
            
                                </div>
            
                        </div>
                        </div>
                    </div>
                    <h1 class="title-bottom">
                        Asaph Gosen.
                    </h1>
                </div>
                <div class="text-three">

                                                <div class="btn">
                                
                                 <a href="#footer" class="nav-link"><span class="btn-bg">contact me</span></a>
                            </div>
                        
                   
                </div>
            </div>

            <div class="image-hero-container">

                <img class="rotated-image" src="@/assets/me2.png" alt="image">
            </div>


        </div>

    </section>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="css">
    
</style>